/* global debounce, localData */
const searchHeaderPosts = (search, searchResultElem) => {
  if (search.value) {
    axios
      .post(
        localData.siteURL,
        { action: 'searchPostsHeader', keyword: search.value, lang: localData.lang, id: localData.id },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((response) => {
        searchResultElem.classList.add('is-active');
        const searchResultInner = document.querySelector('.header-search__results-inner');
        searchResultInner.innerHTML = response.data.html;
      });
  } else {
    searchResultElem.classList.remove('is-active');
  }
};

const searchField = document.querySelector('.header-search__input-field');
if (searchField) {
  const searchParentElem = searchField.closest('.header-search');
  const searchResultElem = searchParentElem.querySelector('.header-search__results');
  searchField.addEventListener(
    'keyup',
    debounce(() => {
      searchHeaderPosts(searchField, searchResultElem);
    }, 300),
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      searchResultElem.classList.remove('is-active');
      searchField.blur();
    }
  });

  document.addEventListener('click', (evt) => {
    if (!searchParentElem.contains(evt.target)) {
      searchResultElem.classList.remove('is-active');
      searchField.blur();
    }
  });

  searchParentElem.addEventListener('click', (evt) => {
    evt.stopPropagation();
  });
}

// **************************************************

const headerSearch = document.querySelector('.header-search');

if (headerSearch) {
  const updateHeaderSearchHeight = () => {
    const height = headerSearch.offsetHeight;
    document.documentElement.style.setProperty('--header-search-height', `${height}px`);
  };

  updateHeaderSearchHeight();

  new ResizeObserver(updateHeaderSearchHeight).observe(headerSearch);
}
